(ns journal-app-client.views
  (:require [journal-app-client.routes :as routes]
            [journal-app-client.views.layout :as layout]
            [journal-app-client.views.home :as home]
            [journal-app-client.views.login :as login]
            [journal-app-client.views.hidden :as hidden]
            [journal-app-client.views.game :as game]
            [journal-app-client.views.special :as special]
            [re-frame.core :as rf]
            [reagent.core :as r]))

(defn default-view [& [props]]
  [:div.container [:p.title "NOT FOUND: Undefined view key given"]])
(defn views [& [id props]]
  (case id
    :home [home/view props]
    :login [login/view props]
    :hidden [hidden/view props]
    :game [:f> game/view props]
    :special [special/view props]
    [default-view props]))

(defonce view-nav
  (r/atom
    (let [query-map (routes/uri->query-map)
          initial-view (or (:view (get routes/setup (keyword (:view query-map)))) :home)
          initial-props {:sub-view (keyword (:sub-view query-map))
                         :query-map (dissoc query-map :view :sub-view)}]
      {:selected-view [initial-view initial-props]
       :active-view [:waiting {:query-map {}}]})))

(defn select-view [view props db]
  (let [push-state? (:push-state? props)
        props (dissoc props :push-state?)
        current-view-nav @view-nav
        previous-props (dissoc (second (:selected-view current-view-nav)) :push-state?)
        selected-view (:selected-view current-view-nav)
        new-view-nav (if (= view :previous-view)
                       (assoc current-view-nav
                              :previous-view selected-view
                              :selected-view (or (:previous-view current-view-nav)
                                                 (if (second selected-view)
                                                   [(first selected-view)]
                                                   [:home])))
                       (assoc current-view-nav
                              :previous-view selected-view
                              :selected-view [view props]))
        active-view (:selected-view new-view-nav)]
    (reset! view-nav (assoc new-view-nav :selected-view active-view))
    (cond
      (= view (first selected-view))
      (when (and (not (false? push-state?))
                 (not (= previous-props props)))
        (routes/push-state (first active-view) (second active-view)))
      (= view :previous-view)
      (when-not (false? push-state?)
        (if (:previous-view current-view-nav)
          (routes/push-state (first (:previous-view current-view-nav)) (second (:previous-view current-view-nav)))
          (routes/push-state (if (second selected-view) (first selected-view) :home) nil)))
      :else
      (when-not (false? push-state?)
        (routes/push-state (first active-view) (second active-view))))))

(defn main-fn []
  (let [active-view (:selected-view @view-nav)
        active-view-key (first active-view)
        active-view-props (second active-view)]
    (if (= active-view-key :special)
      [views active-view-key active-view-props]
      [layout/default
       [views active-view-key active-view-props]
       {:active-view active-view}])))

(defn main []
  [:f> main-fn])
